export function isAndroidDevice() {
  const isAndroid = /android/i.test(window.navigator.userAgent);
  const isStandalone =
    ('standalone' in window.navigator && window.navigator.standalone) ||
    window.matchMedia('(display-mode: standalone)').matches;

  return isAndroid && !isStandalone;
}
